/**
 * RecipientDisplay
 * Displays recipient name with clean typography.
 */

import { cn } from '@/lib/utils';

import type { RecipientEntityType } from '../../types';

interface RecipientDisplayProps {
  displayName: string | null | undefined;
  entityType?: RecipientEntityType | null;
  entityId?: string | null;
  isRead?: boolean;
  className?: string;
}

/** Renders recipient name */
export const RecipientDisplay: React.FC<RecipientDisplayProps> = ({
  displayName,
  isRead = true,
  className,
}) => {
  if (!displayName) {
    return (
      <span className={cn('text-stone-400 text-sm italic', className)}>
        No recipient
      </span>
    );
  }

  return (
    <span
      className={cn(
        'text-sm truncate transition-colors block',
        isRead ? 'text-stone-600' : 'text-stone-900 font-medium',
        className,
      )}
      title={displayName}
    >
      {displayName}
    </span>
  );
};
